import { Component } from "react";
import { Card, Button, Row, Col, Table, Badge, Form, Spinner } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSearch, FaCopy } from "react-icons/fa";
import { withRouter } from "../../common/with-router";
import api from "../../services/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Paginacao from "../../common/pagination";
import AsyncSelect from "react-select/async";
import { carregarTiposEventos } from "../../services/eventosForm";

class FormulariosEventos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            // Agora armazenamos o objeto completo da resposta da API para compatibilidade com o componente Paginacao
            dadosApi: null, 
            paginaAtual: 1,
            itensPorPagina: 20,
            filtroEvento: "",
            filtroPrograma: null,
            erro: "",
            eventosDisponiveis: [],
        };
    }

    componentDidMount() {
        this.carregarDadosIniciais();
        this.carregarFormularios();
    }

    carregarDadosIniciais = async () => {
        const eventos = await carregarTiposEventos();
        this.setState({ eventosDisponiveis: eventos });
    }

    carregarFormularios = () => {
        this.setState({ loading: true, erro: "" });

        let url = `/formularios-eventos/?page=${this.state.paginaAtual}&page_size=${this.state.itensPorPagina}`;

        if (this.state.filtroEvento) {
            url += `&evento=${this.state.filtroEvento}`;
        }
        if (this.state.filtroPrograma?.value) {
            url += `&programa_id=${this.state.filtroPrograma.value}`;
        }

        api.get(url)
            .then((response) => {
                this.setState({
                    dadosApi: response.data,
                    loading: false,
                });
            })
            .catch((error) => {
                console.error("Erro ao carregar formulários:", error);
                let erro = "Erro ao carregar formulários";
                if (error.response?.status === 500) {
                    erro = "Servidor indisponível";
                } else if (error.response?.status === 404) {
                    // API ainda não existe - mostrar mensagem amigável
                    erro = "API de formulários ainda não configurada no backend";
                }
                this.setState({ loading: false, erro, dadosApi: null });
            });
    };

    carregarProgramas = (inputValue) => {
        return new Promise((resolve) => {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
                if (this.lastResolve) this.lastResolve([]);
            }

            this.lastResolve = resolve;

            this.debounceTimer = setTimeout(async () => {
                try {
                    const response = await api.get(`/programas/?nome=${inputValue}`);
                    const options = response.data.results.map((programa) => ({
                        value: programa.id,
                        label: programa.nome,
                    }));
                    resolve(options);
                } catch (error) {
                    console.error("Erro ao carregar programas:", error);
                    resolve([]);
                }
            }, 500);
        });
    };

    handleFiltroEventoChange = (e) => {
        this.setState({ filtroEvento: e.target.value, paginaAtual: 1 }, () => {
            this.carregarFormularios();
        });
    };

    handleFiltroProgramaChange = (selectedOption) => {
        this.setState({ filtroPrograma: selectedOption, paginaAtual: 1 }, () => {
            this.carregarFormularios();
        });
    };

    handlePageChange = (pagina) => {
        this.setState({ paginaAtual: pagina }, () => {
            this.carregarFormularios();
        });
    };

    handleNovoFormulario = () => {
        this.props.router.navigate("/formularios-eventos/edit");
    };

    handleEditarFormulario = (id) => {
        this.props.router.navigate(`/formularios-eventos/edit/${id}`);
    };

    handleDuplicarFormulario = async (formulario) => {
        const MySwal = withReactContent(Swal);

        const result = await MySwal.fire({
            title: "Duplicar Formulário?",
            text: `Deseja criar uma cópia de "${formulario.nome}"?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, duplicar",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                const programaId =
                    typeof formulario.programa === "object"
                        ? formulario.programa?.id
                        : formulario.programa;

                const novoFormulario = {
                    nome: `${formulario.nome} (Cópia)`,
                    evento: formulario.evento,
                    programa: programaId || null,
                    campos: formulario.campos,
                    titulo_modal: formulario.titulo_modal,
                    descricao: formulario.descricao,
                    ativo: false,
                };

                await api.post("/formularios-eventos/", novoFormulario);

                MySwal.fire({
                    icon: "success",
                    title: "Duplicado!",
                    text: "Formulário duplicado com sucesso.",
                    timer: 2000,
                    showConfirmButton: false,
                });

                this.carregarFormularios();
            } catch (error) {
                console.error("Erro ao duplicar:", error);
                MySwal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Não foi possível duplicar o formulário.",
                });
            }
        }
    };

    handleExcluirFormulario = async (formulario) => {
        const MySwal = withReactContent(Swal);

        const result = await MySwal.fire({
            title: "Excluir Formulário?",
            text: `Tem certeza que deseja excluir "${formulario.nome}"? Esta ação não pode ser desfeita.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, excluir",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/formularios-eventos/${formulario.id}/`);

                MySwal.fire({
                    icon: "success",
                    title: "Excluído!",
                    text: "Formulário excluído com sucesso.",
                    timer: 2000,
                    showConfirmButton: false,
                });

                this.carregarFormularios();
            } catch (error) {
                console.error("Erro ao excluir:", error);
                MySwal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Não foi possível excluir o formulário.",
                });
            }
        }
    };

    getEventoLabel = (eventoSlug) => {
        const evento = this.state.eventosDisponiveis.find((e) => e.value === eventoSlug);
        return evento ? evento.label : eventoSlug;
    };

    render() {
        const { loading, dadosApi, paginaAtual, itensPorPagina, erro, eventosDisponiveis } = this.state;
        const formularios = dadosApi?.results || [];

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Formulários por Eventos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" onClick={this.handleNovoFormulario} size="sm">
                            <FaPlus /> Adicionar Formulário
                        </Button>
                    </Col>
                </Row>

                <Card className="cardDestaque">
                    <Card.Body>
                        {/* Filtros */}
                        <Row className="mb-3">
                            <Col sm={4}>
                                <Form.Group>
                                    <Form.Label>Filtrar por Evento</Form.Label>
                                    <Form.Select
                                        value={this.state.filtroEvento}
                                        onChange={this.handleFiltroEventoChange}
                                    >
                                        <option value="">Todos os eventos</option>
                                        {eventosDisponiveis.map((evento) => (
                                            <option key={evento.value} value={evento.value}>
                                                {evento.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={4}>
                                <Form.Group>
                                    <Form.Label>Filtrar por Programa</Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={this.carregarProgramas}
                                        defaultOptions
                                        isClearable
                                        placeholder="Buscar programa..."
                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                        onChange={this.handleFiltroProgramaChange}
                                        value={this.state.filtroPrograma}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={4} className="d-flex align-items-end">
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        this.setState(
                                            { filtroEvento: "", filtroPrograma: null, paginaAtual: 1 },
                                            () => this.carregarFormularios()
                                        );
                                    }}
                                >
                                    <FaSearch className="me-1" /> Limpar Filtros
                                </Button>
                            </Col>
                        </Row>

                        {/* Loading */}
                        {loading && (
                            <div className="text-center py-5">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Carregando...</p>
                            </div>
                        )}

                        {/* Erro */}
                        {!loading && erro && (
                            <div className="alert alert-warning" role="alert">
                                {erro}
                            </div>
                        )}

                        {/* Tabela */}
                        {!loading && !erro && (
                            <>
                                {formularios.length === 0 ? (
                                    <div className="alert alert-info" role="alert">
                                        Nenhum formulário cadastrado. Clique em &quot;Novo Formulário&quot; para começar.
                                    </div>
                                ) : (
                                    <Table responsive hover>
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Evento</th>
                                                <th>Programa</th>
                                                <th>Campos</th>
                                                <th>Status</th>
                                                <th className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formularios.map((formulario) => (
                                                <tr key={formulario.id}>
                                                    <td>
                                                        <strong>{formulario.nome}</strong>
                                                        {formulario.titulo_modal && (
                                                            <small className="d-block text-muted">
                                                                Modal: {formulario.titulo_modal}
                                                            </small>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Badge bg="info">
                                                            {this.getEventoLabel(formulario.evento)}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        {formulario.programa ? (
                                                            typeof formulario.programa === "object" ? (
                                                                formulario.programa.nome
                                                            ) : (
                                                                `Programa #${formulario.programa}`
                                                            )
                                                        ) : (
                                                            <span className="text-muted">Global</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formulario.campos?.length || 0} campo(s)
                                                    </td>
                                                    <td>
                                                        <Badge bg={formulario.ativo ? "success" : "secondary"}>
                                                            {formulario.ativo ? "Ativo" : "Inativo"}
                                                        </Badge>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            className="me-1"
                                                            onClick={() => this.handleEditarFormulario(formulario.id)}
                                                            title="Editar"
                                                        >
                                                            <FaEdit />
                                                        </Button>
                                                        <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            className="me-1"
                                                            onClick={() => this.handleDuplicarFormulario(formulario)}
                                                            title="Duplicar"
                                                        >
                                                            <FaCopy />
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => this.handleExcluirFormulario(formulario)}
                                                            title="Excluir"
                                                        >
                                                            <FaTrash />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                )}

                                {/* Paginação */}
                                {dadosApi && dadosApi.count > 0 && (
                                    <Paginacao
                                        dados={dadosApi}
                                        loading={loading}
                                        page_numb={paginaAtual}
                                        limit={itensPorPagina}
                                        _onClickPagina={this.handlePageChange}
                                    />
                                )}
                            </>
                        )}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(FormulariosEventos);
